import React, { useEffect, useReducer } from "react";
//import { mountEvents, unmountEvents } from "core/emitter";
import emitter from "core/emitter";
import get from "lodash/get";
import {
  ADMIN_EVENT_FLASH_SUCCESS,
  ADMIN_EVENT_FLASH_ERROR,
  ADMIN_EVENT_FLASH_SUCCESS_VANISH,
  ADMIN_EVENT_FLASH_ERROR_VANISH,
} from "core/emitter/events";
import { ALERT_VANISH_TIME_MS } from "app/views/constants";

import Snackbar from "@material-ui/core/Snackbar";
import UiAlert from "@material-ui/lab/Alert";
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overscrollBehavior: "contain",
    height: "100%",
  },
  snackbar: {
    position: "absolute",
    [theme.breakpoints.up("sm")]: {},
    [theme.breakpoints.down("xs")]: {
      //bottom: 500,
    },
    boxShadow: theme.palette.shadow,
    borderRadius: "5px",
  },

  anchorOriginTopCenter: {
    [theme.breakpoints.up("sm")]: {
      top: "21px",
    },
  },
  alertMessage: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    fontWeight: 600,
    letterSpacing: "0.75px",
    fontSize: "16px",
    color: (props) => {
      switch (props.type) {
        case "success":
          return theme.palette.button.default.color.enable;
        case "error":
          return theme.wisemblyColors.white;
        default:
          return theme.wisemblyColors.white;
      }
    },
  },

  alertIcon: {
    fontSize: 30,
  },
  alertAction: {},

  standardSuccess: {
    backgroundColor: theme.palette.background.box,
    "& .MuiAlert-icon": {
      color: theme.palette.secondary.main,
    },
    "& .MuiAlert-action": {
      color: theme.palette.secondary.main,
    },
  },
  standardError: {
    backgroundColor: theme.wisemblyColors.pastelRed,
    "& .MuiAlert-icon": {
      color: theme.wisemblyColors.white,
    },
    "& .MuiAlert-action": {
      color: theme.wisemblyColors.white,
    },
  },
}));

const AdminAlertReducer = (state, action) => {
  switch (action.type) {
    case "ON_SUCCESS": {
      return {
        ...state,
        type: "success",
        hidden: false,
        content: action.content,
      };
    }
    case "ON_ERROR": {
      return {
        ...state,
        type: "error",
        hidden: false,
        content: action.content,
      };
    }
    case "HIDE": {
      return {
        ...state,
        hidden: true,
        type: null,
        content: null,
      };
    }
  }
};
const AdminAlert = () => {
  const [state, dispatch] = useReducer(AdminAlertReducer, {
    type: null,
    hidden: true,
    content: null,
  });
  const classes = useStyles({ type: state.type });

  const unmountEvents = () => {
    emitter.removeListener(ADMIN_EVENT_FLASH_ERROR, onError);
    emitter.removeListener(ADMIN_EVENT_FLASH_SUCCESS, onSuccess);
    emitter.removeListener(ADMIN_EVENT_FLASH_ERROR_VANISH, onErrorVanish);
    emitter.removeListener(ADMIN_EVENT_FLASH_SUCCESS_VANISH, onSuccessVanish);
  };
  useEffect(() => {
    const mountEvents = () => {
      emitter.on(ADMIN_EVENT_FLASH_ERROR, onError);
      emitter.on(ADMIN_EVENT_FLASH_SUCCESS, onSuccess);
      emitter.on(ADMIN_EVENT_FLASH_ERROR_VANISH, onErrorVanish);
      emitter.on(ADMIN_EVENT_FLASH_SUCCESS_VANISH, onSuccessVanish);
    };
    mountEvents();
    return () => unmountEvents();
  }, [unmountEvents]);

  const onError = (content) => {
    dispatch({ type: "ON_ERROR", content: get(content, "message", "") });
  };

  const onSuccess = (content) => {
    //section is present if not provided

    dispatch({ type: "ON_SUCCESS", content: get(content, "message", "") });
  };

  const onSuccessVanish = (content, vanishTimeMs = ALERT_VANISH_TIME_MS) => {
    onSuccess(content);

    setTimeout(() => {
      onClose();
    }, vanishTimeMs);
  };

  const onErrorVanish = (content, vanishTimeMs = ALERT_VANISH_TIME_MS) => {
    onError(content);

    setTimeout(() => {
      onClose();
    }, vanishTimeMs);
  };

  const onClose = () => {
    dispatch({ type: "HIDE" });
    //this.setState({ hidden: true });
  };

  const computeClass = (type) => {
    switch (type) {
      default:
        return "success";
      case "success":
      case "error":
      case "warning":
        return type;
    }
  };

  //dont forget to reset timeout
  return (
    <Snackbar
      open={!state.hidden}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      classes={{
        root: classes.snackbar,
        //anchorOriginBottomCenter: classes.anchorOriginBottomCenter,
        anchorOriginTopCenter: classes.anchorOriginTopCenter,
      }}
    >
      <UiAlert
        iconMapping={{
          success: <CheckOutlinedIcon classes={{ root: classes.alertIcon }} />,
          error: (
            <ErrorOutlineOutlinedIcon classes={{ root: classes.alertIcon }} />
          ),
        }}
        classes={{
          message: classes.alertMessage,
          standardSuccess: classes.standardSuccess,
          standardError: classes.standardError,
        }}
        severity={computeClass(state.type)}
      >
        {state.content}
      </UiAlert>
    </Snackbar>
  );
};

AdminAlert.propTypes = {};
AdminAlert.defaultProps = {};

export default AdminAlert;
